import { toJS } from 'mobx';
import { INTERNAL_CONTAINER } from '../constants';
import { Comp } from './page-view/types';
import { getChildComs } from './page-view/utils';

export default abstract class BasePageViewStore {
  abstract coms: Comp[];

  getCom = (comId: string) => {
    const com = toJS(this.coms.find((_com) => _com.id === comId));

    return com;
  };

  getChildComs = (comId: string): Comp[] => {
    const com = this.coms.find((_com) => _com.id === comId);

    if (com) {
      const _childComs = getChildComs(com, this.coms);
      const res: Comp[] = [];

      const getChilds = (childComs: any[]) => {
        childComs.forEach((childCom) => {
          if (childCom && childCom.type !== INTERNAL_CONTAINER) {
            res.push(childCom);
          }
          if (childCom.childComs.length) {
            getChilds(childCom.childComs);
          }
        });
      };

      getChilds(_childComs);

      return res;
    }

    return [];
  };

  getParentCom = (comId: string): Comp | null => {
    const com = this.coms.find(({ id }) => id === comId);

    if (com) {
      const parent = com.config.flow?.parent;

      if (parent) {
        const parentCom = this.getCom(parent)!;
        const { type, id } = parentCom;

        if (type !== INTERNAL_CONTAINER) {
          return parentCom;
        }

        return this.getParentCom(id);
      }
    }

    return null;
  };

  getParentComs = (comId: string) => {
    const parentComs: Comp[] = [];
    let parentCom = this.getParentCom(comId);

    while (parentCom) {
      parentComs.push(parentCom);
      parentCom = this.getParentCom(parentCom.id);
    }

    return parentComs;
  };

  getDroppableCom = (comId: string, droppableId: string) => {
    const com = this.coms.find((_com) => _com.id === comId);

    if (com) {
      const _comId = (com as any).config.flow?.linkedNodes?.[droppableId];

      return this.getCom(_comId);
    }

    return null;
  };
}
